









































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import MultiqContentIdChip from '@/ui/components/atoms/groupingItems/MultiqContentIdChip.vue';
import { isNotEmpty } from '@/ui/services/admin/InputVerification';
import getLogger from '@/shared/logger/logger';
import { ImportCampaignDTO } from '@/core/campaign/DTO/ImportCampaignDTO';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = getLogger('ImportCampaignForm');

interface VForm extends HTMLFormElement {
  validate(): boolean;
  reset(): boolean;
}

const CONTENT_ID_REGEX = /^\d+$/;

@Component({
  name: 'ImportCampaignForm',
  components: { MultiqContentIdChip },
})
export default class ImportCampaignForm extends Vue {
  @Prop({ default: false }) saveNew: boolean | undefined;
  multiqContentIdInput = '';
  multiqContentIds: string[] = [];
  title = '';
  description = '';

  @Watch('multiqContentIdInput') onEnterIdOrUrl(newValue: string) {
    if (newValue === '' || CONTENT_ID_REGEX.test(newValue)) {
      LOG.debug(`content id '${newValue}' seems to be empty/valid, skipping URL parsing`);
      return;
    }
    let url = null;
    try {
      url = new URL(newValue);
    } catch {
      LOG.debug('input is not a URL, treating as plain ID');
    }
    if (url !== null) {
      LOG.debug(`trying to decode content id from URL pathname '${url.pathname}'`);
      if (url.pathname.startsWith('/content/') && url.pathname.endsWith('/edit')) {
        const onlyContentId = url.pathname.replace('/content/', '').replace('/edit', '');
        this.multiqContentIdInput = onlyContentId;
      }
    }
  }

  addMultiqContentIdFromInput() {
    if (this.multiqContentIdInput === '') {
      return;
    }
    this.multiqContentIds.push(this.multiqContentIdInput);
    this.multiqContentIdInput = '';
  }

  @Watch('saveNew')
  onSave(newValue: boolean) {
    if (this.isAllInputValid() && newValue) {
      const importCampaignDTO: ImportCampaignDTO = {
        multiqContentIds: this.multiqContentIds,
        title: this.title,
        description: this.description,
      };
      this.$emit('doImport', importCampaignDTO);
    } else {
      this.$emit('inputIsInvalid');
    }
  }

  get isNotEmpty() {
    return isNotEmpty;
  }
  get contentIdRegex() {
    return CONTENT_ID_REGEX;
  }

  isAllInputValid() {
    const ref = this.$refs.form as VForm;
    return (
      ref.validate() &&
      this.multiqContentIds.length !== 0 &&
      this.multiqContentIds.every((multiqContentId) => CONTENT_ID_REGEX.test(multiqContentId))
    );
  }

  clearInput() {
    this.multiqContentIdInput = '';
    this.multiqContentIds = [];
    this.title = '';
    this.description = '';
  }
}
